<div class="subcomponent-inner-wrap" xmlns="http://www.w3.org/1999/html">
	<mat-card style="font-size: 14px" class="acies-card">
		<mat-card-content>
			<router-outlet></router-outlet>
		</mat-card-content>
	</mat-card>
</div>

<ng-template #rightSidebarContent>
	<app-sidebarwidget [icon]="'acies_analytics'" [heading]="'insights.right_sidebar.select_report' | translate" class="report-list">
		<mat-selection-list [multiple]="false" #report class="no-top-padding" [hideSingleSelectionIndicator]="true">
			@if (dataFiltered$ | async; as data) {
				<div id="widgetReportList">
					@for (item of data | filter: 'name' : inputReport.value; track item; let ix = $index) {
						<app-list-item [item]="item" [index]="ix" (selected)="itemSelected($event)"></app-list-item>
					}
				</div>
			} @else {
				{{ 'insights.right_sidebar.loading_data' | translate }}
			}
		</mat-selection-list>

		<mat-form-field appearance="outline" id="widgetReportSearch">
			<mat-label>{{ 'insights.right_sidebar.filter_reports' | translate }}</mat-label>
			<input matInput type="search" [placeholder]="'insights.right_sidebar.filter_reports' | translate" [formControl]="filter" autocomplete="off" (keyup)="onKeydown($event)" #inputReport id="inputreport" />
			<button mat-icon-button matPrefix>
				<mat-icon svgIcon="acies_search"></mat-icon>
			</button>
		</mat-form-field>

		<div class="button-bar auto-top-margin no-bottom-margin">
			<button mat-flat-button (click)="activateSlideshow()" color="primary" class="slideshow-button" [disabled]="noReports">
				{{ 'insights.right_sidebar.start_slideshow' | translate }}
				<mat-icon svgIcon="acies_slideshow"></mat-icon>
			</button>
		</div>

		@if (impersonateUser) {
			<div class="userinfo-reports" id="userinfoReports">
				<div class="wrap">
					{{ 'insights.right_sidebar.logged_in_as' | translate }}:
					<br />
					<div class="ellipsis">{{ impersonateUser.name }} ({{ impersonateUser.email }})</div>
				</div>
				<mat-icon svgIcon="acies_logout" (click)="exitImpersonation()" title="Log out"></mat-icon>
			</div>
		}
	</app-sidebarwidget>
</ng-template>
